import { useState } from 'react';
import api from '../services/api';
import { getSessionId } from '../utils/helpers';

export function useCouponReport() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState('');
  const [submitted, setSubmitted]   = useState(false);

  const reportBroken = async (couponId, reportType, description) => {
    setSubmitting(true); setError('');
    try {
      await api.post(`/coupons/${couponId}/report`, {
        report_type: reportType,
        description,
        session_id: getSessionId(),
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not submit report. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const confirmWorking = async (couponId) => {
    try { await api.post(`/coupons/${couponId}/confirm-working`); return true; }
    catch { return false; }
  };

  const reset = () => { setSubmitted(false); setError(''); };

  return { reportBroken, confirmWorking, submitting, submitted, error, reset };
}
